export const environment = {
  production: true,
  apiUrl: 'https://stream-sphere-azure.vercel.app/api'
}; 